<template>
  <div class="">
    <p
      v-if="!hideLabel"
      :for="name"
      class="flex items-center gap-2 mb-2 pl-4 text-base font-medium dark:text-gray-300 text-primary h-5"
    >
      {{ $t(label || "") }}<span v-if="required" class="text-danger"> *</span>
    </p>
    <div class="flex items-center">
      <div class="flex items-center">
        <label :for="id"></label>
      </div>
      <label
        :for="id"
        class="ml-3 inline-flex relative items-center cursor-pointer gap-2 dark:text-gray-300"
        :class="[{ 'text-secondary': errorMessage }, { 'text-lg md:text-2xl font-semibold': size }]"
      >
        <input
          :type="type"
          :id="id"
          :name="name"
          :checked="checked"
          :value="value"
          @change="onChange"
          class="sr-only peer"
          :class="[
            {
              'input-error': errorMessage,
            },

            size ? 'h-7 w-7 md:h-10 md:w-10' : 'h-5 w-5',
          ]" />
        <div
          class="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"
        ></div>
        <span class=" font-semibold text-gray-900 dark:text-gray-300">
          <slot>{{ $t(text || "") }}</slot></span
        >

        <tippy v-if="tooltip" class="flex items-center justify-center">
          <BaseIcon name="info" class="text-success hover:ring-success" />
          <template #content>
            <slot name="tooltip" />
          </template> </tippy
      ></label>
    </div>
    <template v-if="single">
      <span v-show="errorMessage" class="alert-error">
        {{ $t(errorMessage || "") }}
      </span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import {  toRefs } from "vue";
import { useField } from "vee-validate";
import { useVModel } from "@vueuse/core";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  label: String,
  text: String,
  name: String,
  type: {
    type: String,
    default: "checkbox",
  },
  size: {
    type: Boolean,
    default: false,
  },
  id: String,
  placeholder: String,
  cvalue: {
    type: [Boolean, String, Number],
    default: false,
  },
  modelValue: {
    type: [Boolean, String, Number],
    default: true,
  },
  btn: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
  single: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: true,
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: false,
  },
});

const { checkedValue, uncheckedValue, modelValue, name } = toRefs(props);

const { value, errorMessage, checked, handleChange } = useField(name, undefined, {
  initialValue: modelValue,
  type: props.type,
  checkedValue: checkedValue,
  // valueProp: toRef(props, "modelValue"),
  uncheckedValue: uncheckedValue,
});
// handleChange(modelValue.value);
const onChange = (e) => {
  const v = e.target.checked ? checkedValue.value : uncheckedValue.value;
  emit("update:modelValue", v);
};
</script>

<style scoped></style>
